export default function reducer(state={
    city:null
},action) {
    switch (action.type){
        default:
            break
    }
    return state
}



// WEBPACK FOOTER //
// ./src/reducers/homeReducer.js